import { render, staticRenderFns } from "./o-select.vue?vue&type=template&id=9bdc2acc&scoped=true&"
import script from "./o-select.vue?vue&type=script&lang=js&"
export * from "./o-select.vue?vue&type=script&lang=js&"
import style0 from "./o-select.vue?vue&type=style&index=0&id=9bdc2acc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bdc2acc",
  null
  
)

export default component.exports